import { DeliveryModel } from '@audibene/ta.utils-opportunity'
import { AppointmentType, Country } from '../../constants'
import { getDeliveryModelFromJourney } from '../getDeliveryModelFromJourney'

interface IsPooledSchedulingInScopeParameters {
  appointmentType?: AppointmentType | string | null
  country?: Country | string | null
  journey?: string | null
}

const isPooledSchedulingInScope = ({ appointmentType, country, journey }: IsPooledSchedulingInScopeParameters): boolean =>
  appointmentType === AppointmentType.HEARING_AID_EVALUATION &&
  country === Country.US &&
  getDeliveryModelFromJourney(journey as string) === DeliveryModel.TELEAUDIOLOGY

export { isPooledSchedulingInScope }
